module.exports = __webpack_public_path__ + "img/pic-11.d0dc512e.jpg";